/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisIndicatorsAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of visualization indicators available
 */
define([], () => {
	class VisIndicatorsAPI {

		/**
		 * @function VisIndicatorsAPI#registerProvider
		 * @description Register a provider as a visualization indicator provider
		 * @param {name} name of the provider
		 * @param {provider} provider visIndicator provider to register and contribute indicators
		 */
		registerProvider(/* name, provider */) {}

		/**
		 * @function VisIndicatorsAPI#getIndicatorList
		 * @description Returns a list of indicators available
		 * @return {array} array containing all available indicators
		 */
		getIndicatorList() {}

	}

	return VisIndicatorsAPI;
});